export const DESIGN_REGISTRY_GET_BOT_DESIGN = 'DESIGN_REGISTRY_GET_BOT_DESIGN';
export const DESIGN_REGISTRY_GET_BOT_DESIGN_SUCCESS = 'DESIGN_REGISTRY_GET_BOT_DESIGN_SUCCESS';
export const DESIGN_REGISTRY_GET_BOT_DESIGN_FAIL = 'DESIGN_REGISTRY_GET_BOT_DESIGN_FAIL';

export const DESIGN_REGISTRY_GET_BOT_DESIGN_CLEAR = 'DESIGN_REGISTRY_GET_BOT_DESIGN_CLEAR';
